<div class="ongoing-call" [class.is-expanded]="isExpanded" [class.highlight]="useHighlight">
  <div class="details">
    <div class="name hide-when-minimized" [matTooltip]="call.name">{{ call.name }}</div>
    @if (statusMessage !== null) {
      <div class="status-container">
        @if (displayStatusButtons && call.latestCallSession !== null) {
          @if (call.latestCallSession.status === 'CONNECTED') {
            <mat-icon class="icon state-icon recording-icon" fontIcon="radio_button_checked"></mat-icon>
            <mat-icon
              class="icon action-icon"
              fontIcon="pause"
              [matTooltip]="'CALLS.ONGOING_CALLS.RECORDING_PAUSE.TITLE' | translate"
              (click)="pauseRecording(call)"
            ></mat-icon>
          } @else if (call.latestCallSession.status === 'PAUSED') {
            <mat-icon class="icon state-icon" fontIcon="pause"></mat-icon>
            <mat-icon
              class="icon action-icon"
              fontIcon="play_arrow"
              [matTooltip]="'CALLS.ONGOING_CALLS.RECORDING_RESUME.TITLE' | translate"
              (click)="resumeRecording(call)"
            ></mat-icon>
          }
        }
        <span class="status hide-when-minimized">{{ statusMessage }}</span>
      </div>
    }
    @if (displayExtendIconButton) {
      <div class="recording-stops">
        <div
          class="recording-stops-minimized show-when-minimized"
          [matTooltip]="'CALLS.ONGOING_CALLS.RECORDING_STOPS.TOOLTIP' | translate: { time: recordingStopsAtLabel }"
        >
          <mat-icon class="countdown-icon" fontIcon="timer"></mat-icon>
          <span>{{ recordingRemaining }}</span>
        </div>
        <div class="recording-stops-expanded hide-when-minimized">
          <span
            [matTooltip]="'CALLS.ONGOING_CALLS.RECORDING_STOPS.TOOLTIP' | translate: { time: recordingStopsAtLabel }"
            [innerHtml]="'CALLS.ONGOING_CALLS.RECORDING_STOPS.LABEL' | translate: { time: recordingRemaining }"
          ></span>
          <button mat-icon-button mat-small-icon-button [matTooltip]="'CALLS.EXTEND_STAY.CARD_BUTTON' | translate" (click)="extend(call)">
            <mat-icon>more_time</mat-icon>
          </button>
        </div>
      </div>
    }
    @if (displaySkipToNextSubMeetingButton) {
      <div class="sub-meeting-container">
        <mat-icon
          class="icon action-icon skip-button"
          fontIcon="double_arrow"
          [matTooltip]="'CALLS.ONGOING_CALLS.PROCEED_TO_NEXT_SUB_CALL.TITLE' | translate"
          (click)="switchToNextSubMeeting(call)"
        ></mat-icon>
        <span>
          <span class="hide-when-minimized">{{ 'CALLS.ONGOING_CALLS.SUB_CALL' | translate }}</span>
        </span>
        <span> #{{ call.totalNumberOfSplits + 1 }} </span>
      </div>
    }
    @if (call.currentParticipantCount !== null) {
      <div class="participants-container hide-when-minimized" [matTooltip]="currentParticipantText">
        <mat-icon fontIcon="group"></mat-icon>
        <div class="participant-text">
          {{ currentParticipantText }}
        </div>
      </div>
    }
  </div>
  <div class="buttons">
    <div class="top-buttons">
      <button
        mat-icon-button
        class="hang-up-button"
        color="accent"
        [disabled]="call.latestCallSession === null"
        [matTooltip]="'COMMON.HANG_UP' | translate"
        (click)="hangUp(call)"
      >
        <mat-icon>phone_disabled</mat-icon>
      </button>
    </div>
    <div class="bottom-buttons hide-when-minimized">
      @if (canJoinNow) {
        <button mat-icon-button [matTooltip]="'CALLS.JOIN_IMMEDIATELY.BUTTON_TOOLTIP' | translate" (click)="joinNow(call)">
          <mat-icon fontSet="material-symbols-outlined" style="transform: rotate(180deg)">start</mat-icon>
        </button>
      }
      <button mat-icon-button [matMenuTriggerFor]="menu" (menuOpened)="menuOpened.emit()" (menuClosed)="menuClosed.emit()">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item translate="COMMON.JOIN" (click)="join(call)"></button>
        <button mat-menu-item translate="COMMON.HANG_UP" (click)="hangUp(call)"></button>
        @if (canJoinNow) {
          <button mat-menu-item translate="CALLS.JOIN_IMMEDIATELY.BUTTON_TOOLTIP" (click)="joinNow(call)"></button>
        }
        @if (call.latestCallSession !== null) {
          @if (call.latestCallSession.status === 'CONNECTED') {
            <button mat-menu-item translate="CALLS.ONGOING_CALLS.RECORDING_PAUSE.TITLE" (click)="pauseRecording(call)"></button>
          } @else if (call.latestCallSession.status === 'PAUSED') {
            <button mat-menu-item translate="CALLS.ONGOING_CALLS.RECORDING_RESUME.TITLE" (click)="resumeRecording(call)"></button>
          }
        }
        @if (displayExtendButton) {
          <button mat-menu-item translate="CALLS.EXTEND_STAY.CARD_BUTTON" (click)="extend(call)"></button>
        }
        @if (displaySkipToNextSubMeetingButton) {
          <button mat-menu-item translate="CALLS.ONGOING_CALLS.PROCEED_TO_NEXT_SUB_CALL.TITLE" (click)="switchToNextSubMeeting(call)"></button>
        }
        <a [routerLink]="['/app', 'meetings', call.id, 'setup']" queryParamsHandling="merge">
          <button mat-menu-item translate="COMMON.CALL_INFO"></button>
        </a>
      </mat-menu>
    </div>
  </div>
</div>
